import { create } from 'zustand';

interface AIFilterState {
  /** IDs спортсменов для фильтрации (из AI чата) */
  filterIds: string[] | null;
  /** Описание фильтра для UI */
  filterLabel: string | null;

  /** Установить AI-фильтр */
  setFilter: (ids: string[], label: string) => void;
  /** Сбросить AI-фильтр */
  clearFilter: () => void;
}

export const useAIFilterStore = create<AIFilterState>((set) => ({
  filterIds: null,
  filterLabel: null,

  setFilter: (ids: string[], label: string) => {
    set({ filterIds: ids, filterLabel: label });
  },

  clearFilter: () => {
    set({ filterIds: null, filterLabel: null });
  },
}));
